import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions';

export default (build: EndpointBuilder<any, any, any>) =>
  build.query<Response, QueryParams>({
    query: (params) => {
      const queryParams = new URLSearchParams();

      if (params.per_page) queryParams.append('per_page', params.per_page.toString());
      if (params.page) queryParams.append('page', params.page.toString());

      return {
        url: `v5/link/${params.id}/activity-logs${
          queryParams.toString() ? `?${queryParams.toString()}` : ''
        }`,
        method: 'GET',
      };
    },
  });

export interface QueryParams {
  id: number;
  per_page?: number;
  page?: number;
}

export interface ActivityLog {
  id: number;
  action: string;
  description: string;
  user_name?: string;
  user_id?: number;
  user?: {
    id: number;
    name: string;
    email: string;
  };
  ip_address?: string;
  user_agent?: string;
  platform?: string;
  browser?: string;
  device_type?: string;
  created_at: string;
  metadata?: Record<string, any>;
}

interface Response {
  data: ActivityLog[];
  meta?: {
    current_page: number;
    last_page: number;
    total: number;
    per_page: number;
  };
}
